import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Toaster } from '@/pet/src/components/ui/sonner';
import { ThemeProvider } from '@/pet/src/context/ThemeContext';
import { PetsProvider } from '@/pet/src/context/PetsContext';
import { ProposedRecordsProvider } from '@/pet/src/context/ProposedRecordsContext';
import { NotificationsProvider } from '@/pet/src/context/NotificationsContext';
import { OwnerOnboardingProvider } from '@/pet/src/context/OwnerOnboardingContext';
import { AppointmentsProvider } from '@/pet/src/context/AppointmentsContext';
import { SubscriptionProvider } from '@/pet/src/context/SubscriptionContext';
import { RemindersProvider } from '@/pet/src/context/RemindersContext';
import { OnboardingProvider } from '@/pet/src/context/OnboardingContext';
import { SocialConnectionsProvider } from '@/pet/src/context/SocialConnectionsContext';
import { StoriesProvider } from '@/pet/src/context/StoriesContext';
import { AuthProvider } from '@/context/AuthContext';
import { BusinessProvider } from '@/context/BusinessContext';
import { PermissionProvider } from '@/context/PermissionContext';
function RootComponent() {
  return <ThemeProvider>
      <AuthProvider>
        <BusinessProvider>
          <PermissionProvider>
            <SubscriptionProvider>
          <PetsProvider>
            <ProposedRecordsProvider>
              <OwnerOnboardingProvider>
                  <OnboardingProvider>
                    <AppointmentsProvider>
                      <RemindersProvider>
                        <NotificationsProvider>
                          <SocialConnectionsProvider>
                            <StoriesProvider>
                              <Outlet />
                              <Toaster />
                              <TanStackRouterDevtools />
                            </StoriesProvider>
                          </SocialConnectionsProvider>
                        </NotificationsProvider>
                      </RemindersProvider>
                    </AppointmentsProvider>
                  </OnboardingProvider>
              </OwnerOnboardingProvider>
            </ProposedRecordsProvider>
          </PetsProvider>
            </SubscriptionProvider>
          </PermissionProvider>
        </BusinessProvider>
      </AuthProvider>
    </ThemeProvider>;
}
export const Route = createRootRoute({
  component: RootComponent
});